// src/components/ColaboradorDoMes/ColaboradorDoMes.js

import React, { useState, useEffect, useCallback } from 'react';
import { db } from '../../firebaseConfig';
import { collection, query, where, getDocs, orderBy } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';
import { FaTrophy, FaPlus, FaCalendarAlt, FaStore, FaUserCheck, FaMedal, FaChartBar, FaQuoteLeft } from 'react-icons/fa';
import '../../styles/ColaboradorDoMes.css';

const ColaboradorDoMes = ({ userData }) => {
    const [activeSurveys, setActiveSurveys] = useState([]);
    const [pastWinners, setPastWinners]     = useState([]);
    const [loading, setLoading]             = useState(true);
    const navigate  = useNavigate();
    const empresaId = userData?.empresa_id;

    const fetchData = useCallback(async () => {
        if (!empresaId) return;
        setLoading(true);
        try {
            const surveysRef = collection(db, 'Empresas', empresaId, 'employeeOfMonth');

            const qActive = query(surveysRef, where('status', '==', 'active'),  orderBy('createdAt', 'desc'));
            const qPast   = query(surveysRef, where('status', '==', 'closed'), orderBy('endedAt',   'desc'));

            const [activeSnap, pastSnap] = await Promise.all([getDocs(qActive), getDocs(qPast)]);

            setActiveSurveys(activeSnap.docs.map(d => ({ id: d.id, ...d.data() })));
            setPastWinners(pastSnap.docs.map(d => ({ id: d.id, ...d.data() })));
        } catch (err) {
            console.error("Erro ao carregar Colaborador do Mês:", err);
        } finally {
            setLoading(false);
        }
    }, [empresaId]);

    useEffect(() => { fetchData(); }, [fetchData]);

    if (loading) return <div className="loading-container"><div className="spinner"></div></div>;

    return (
        <div className="colaborador-mes-container">
            <header className="page-header-premium">
                <div>
                    <h1><FaTrophy className="icon-gold" /> Colaborador do Mês</h1>
                    <p>Reconhecendo a excelência e os valores da nossa cultura.</p>
                </div>
                {userData?.departamento === 'People' && (
                    <button className="btn-premium-action" onClick={() => navigate('/colaborador-do-mes/criar')}>
                        <FaPlus /> Nova Campanha
                    </button>
                )}
            </header>

            {/* VOTAÇÕES ATIVAS */}
            <section className="surveys-section">
                <h3 className="section-subtitle"><FaCalendarAlt /> Votações em Aberto</h3>
                {activeSurveys.length > 0 ? (
                    <div className="surveys-grid">
                        {activeSurveys.map(survey => (
                            <div key={survey.id} className="survey-card-premium">
                                <div className="survey-card-badge">Ativo</div>
                                <h4>{survey.title}</h4>
                                <div className="survey-info-row">
                                    <span><FaStore /> {survey.scope === 'global' ? 'Global' : survey.scopeValue}</span>
                                    <span><FaUserCheck /> {survey.candidates?.length} Candidatos</span>
                                </div>
                                <div style={{display:'flex', gap:'10px', marginTop:'20px'}}>
                                    <button className="btn-vote-now" style={{flex:1, marginTop:0}} onClick={() => navigate(`/colaborador-do-mes/votar/${survey.id}`)}>
                                        Votar Agora
                                    </button>
                                    {(userData?.departamento === 'People' || userData?.role === 'Admin') && (
                                        <button
                                            className="btn-premium-action"
                                            style={{marginTop:0, padding:'10px'}}
                                            title="Apurar e Encerrar"
                                            onClick={() => navigate(`/colaborador-do-mes/gerenciar/${survey.id}`)}>
                                            <FaChartBar />
                                        </button>
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>
                ) : (
                    <div className="empty-state-light">Não há votações ativas no momento.</div>
                )}
            </section>

            {/* MURAL DE HONRA */}
            <section className="hall-of-fame">
                <h3 className="section-subtitle"><FaMedal className="icon-gold" /> Mural de Honra</h3>
                {pastWinners.length > 0 ? (
                    <div className="winners-history-grid">
                        {pastWinners.map(winner => (
                            <div key={winner.id} className="winner-history-card">
                                <div className="winner-photo-wrapper">
                                    <img src={winner.winnerPhoto || 'https://via.placeholder.com/150'} alt={winner.winnerName} />
                                    <div className="medal-overlay"><FaMedal /></div>
                                </div>
                                <div className="winner-details">
                                    <h5>{winner.winnerName}</h5>
                                    <p className="winner-period">{winner.month} / {winner.year}</p>
                                    <p className="winner-scope">{winner.scopeValue || 'Geral'}</p>
                                    {winner.winnerMessage && (
                                        <blockquote className="winner-message">
                                            <FaQuoteLeft className="quote-icon" />
                                            {winner.winnerMessage}
                                        </blockquote>
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>
                ) : (
                    <div className="empty-state-dark">Ainda não há vencedores registrados.</div>
                )}
            </section>
        </div>
    );
};

export default ColaboradorDoMes;